// extracted by mini-css-extract-plugin
export default {"modal":"SelectPushStaff_modal__Euwd3","tips":"SelectPushStaff_tips__hg9dD"};